import React, { useEffect, useState } from "react";
//import { Redirect } from "react-router";
import * as images from "../../constants/Images";
import Avatar from "react-avatar";
import AddComment from "../AddComment/AddComment";
import AddAnswer from "../AddAnswer/AddAnswer";
import PropTypes from "prop-types";
import "./DataCards2.css";
import Loadspinner from "../Loadspinner";
import { format } from "date-fns";
//import { base_url } from "../../constants/ApiEndpoints";

import BookmarksService from "../../services/BookmarksService";

//import GoogleDocsViewer from "react-google-docs-viewer";

import { Redirect } from "react-router";

import { withRouter } from "react-router-dom";
//import { socket } from "../../common/Socket";
import CommonService from "../../services/CommonService";
import CreateKnowledgeService from "../../services/CreateKnowledgeService";
import Encrypt from "../../services/Encryption";
import Decrypt from "../../services/Decryption";
import Loader from "react-loader-spinner";
import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { green } from "@mui/material/colors";
import { Chip, Tooltip, Typography } from "@mui/material";
import store from "../../redux/store";
import { updateBookmarkAction } from "../../redux/actions";
import { APICall } from "../../helpers/API/APICalls";
import { generateSignedPlaylistFile, likeDislike } from "../../constants/ApiEndpoints";
import {
  getFromEncLocalStorage,
  storeInEncLocalStorage,
} from "../../helpers/Utils/Utils";
import VideoJS from "../VideoView/VideoView";

function useForceUpdate() {
  let [value, setState] = useState(true);
  return () => setState(!value);
}

export function ShowAttachment(props) {
  const [id, setId] = useState(getFromEncLocalStorage("accountId"));
  const [location, setLocation] = useState(getFromEncLocalStorage("location"));
  const [token, setToken] = useState("");
  // const [attachmentUrl, setAttachmentUrl] = useState("");
  const [imageData, setImageData] = useState("");
  const [count, setCount] = useState(0);
  const [gcpVideoUrl, setGcpVideoUrl] = useState("");

  // const [showvideo, setShowvideo] = useState(false);
  const { aType, videoId, thumbnail, videoMetadata, isFromAsideCards = false } = props;

  const SASToken = getFromEncLocalStorage("SASToken");

  useEffect(() => {
    //getData();
    generateSignedPlaylistFile1();
  }, []);

  useEffect(() => {
    if (SASToken != "" && SASToken != undefined && SASToken != null) {
      downloadBlobs(props.attachment);
      // showDocData();
      setCount(count + 1);
    }
  }, [SASToken]);

  // useEffect(() => {
  //   if (imageData) {
  //     showDocData();
  //   }
  // }, [imageData]);

  console.log("imageData: ", imageData);
  const downloadBlobs = async (reqData) => {
    console.log("Inside downloadBlobs");
    // if (props.attachment != null || props.attachment != "") {
    //   let reqData = {
    //     url: props.attachment,
    //   };
    let resp = await CommonService.downloadBlob(reqData);
    console.log("Inside downloadBlobs resp: ", resp);

    //   // resp.read().then((val) => console.log(val));
    // console.log("response from download======", resp);
    // setAttachmentUrl(resp);

    let strarray = aType?.split("/");
    console.log("Inside downloadBlobs strarray: ", strarray);
    // console.log('strarray:', strarray);
    // let strgarray = aType.split(".");
    // let docStr = strgarray[strgarray.length - 1];
    let strng = strarray?.[0];
    console.log("Inside downloadBlobs strng: ", strng);
    const renderData = getRenderData(resp, strng, props, isFromAsideCards);
    console.log("Inside downloadBlobs renderData: ", renderData);
    setImageData(renderData);
  };

  const getData = async () => {
    if (videoId != null && videoId != "") {
      // const id = getFromEncLocalStorage("accountId");
      // const location = getFromEncLocalStorage("location");

      let vtoken = await CreateKnowledgeService.getVideoToken(videoId);
      setToken(vtoken);
      // setId(id);
      // setLocation(location);
    }
  };

  const generateSignedPlaylistFile1 = async () => {
    //setVideoLoading(true);
    try {
      if (!gcpVideoUrl && videoMetadata) {
        const request = { playlistContent: videoMetadata };

        const response = await APICall(generateSignedPlaylistFile, request);
        console.log("generateSignedPlaylistFile1 response: ", response)
        if (response?.data) {
          setGcpVideoUrl(response?.data);
        }
      }
    } catch (err) {
      console.log("🚀 ~ file: Video_view.js:103 ~ generateSignedPlaylistFile ~ err:", err);
    } finally {
      //setVideoLoading(false);
    }
  };

  if (aType == null || aType == "") {
    return null;
  }
  //console.log("🚀 ~ file: DataCards2.js:158 ~ aType:", aType);

  //if (props.GcpVideoUrl != "" && props.GcpVideoUrl != null) {
  //console.log("🚀 ~ file: DataCards2.js:164 ~ gcpVideoUrl:", gcpVideoUrl);
  if (isFromAsideCards && thumbnail) {
    return (
      <img
        src={thumbnail}
        style={{
          width: isFromAsideCards ? "5vw" : "37vw",
          height: isFromAsideCards ? "5vw" : "var(--sidebar-width)",
        }}
      />
    )
  }
  if (gcpVideoUrl) {
    return (
      // <video
      //   style={{ width: "100%", height: "auto", maxHeight: "300px" }}
      //   src={props.GcpVideoUrl}
      //   poster={props.ThumbnailGcp}
      //   controls
      // ></video>
      <>
        {isFromAsideCards ? (
          <img
            src={thumbnail}
            style={{
              width: isFromAsideCards ? "5vw" : "37vw",
              height: isFromAsideCards ? "5vw" : "var(--sidebar-width)",
            }}
          />
        ) : (
          <VideoJS url={gcpVideoUrl} type={aType} />
        )}
      </>
    )
  }

  // const showDocData = () => {
  if (
    videoId != null &&
    videoId != "" &&
    (props.attachment == null || props.attachment == "")
  ) {
    //let thumbnailUrl = `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/${videoId}/Thumbnails/${thumbnailId}?accessToken=${token}`;

    let videoUrl = `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/${videoId}/PlayerWidget?accessToken=${token}`;

    let videoThmbnail = `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/${videoId}/Thumbnails/${props.thumbnailId}?accessToken=${token}`;

    // console.log("videoThmbnail: ", videoThmbnail);
    return (
      <p>
        {/* {!showvideo ? (
          <img
            style={{ width: "37vw", height: "var(--sidebar-width)" }}
            src={
              thumbnailId == "00000000-0000-0000-0000-000000000000"
                ? images.thumbnail
                : thumbnailUrl
            }
            onContextMenu={(e) => e.preventDefault()}
            onClick={() => {
              setShowvideo(true);
            }}
          ></img>
        ) : (
          <iframe
            style={{ width: "37vw", height: "var(--sidebar-width)" }}
            src={videoUrl}
            onContextMenu={(e) => e.preventDefault()}
          ></iframe>
        )} */}
        {isFromAsideCards ? (
          <img
            src={videoThmbnail}
            style={{
              width: isFromAsideCards ? "5vw" : "37vw",
              height: isFromAsideCards ? "5vw" : "var(--sidebar-width)",
            }}
          />
        ) : (
          <iframe
            loading="lazy"
            style={{
              width: "37vw",
              height: "var(--sidebar-width)",
            }}
            allowFullScreen
            controls="0"
            autoPlay="0"
            src={videoUrl}
            onContextMenu={(e) => e.preventDefault()}
          ></iframe>
        )}
      </p>
    );
  } else if (aType !== null) {
    return <p>{imageData}</p>;
  } else {
    return null;
  }
  // };
}

const getRenderData = (resp, strng, props, isFromAsideCards = false) => {
  let returnValue = "";
  if (strng == "image") {
    returnValue = (
      <img
        src={resp}
        style={{
          marginTop: "8px",
          border: "1px solid rgb(150,150,150)",
        }}
        onContextMenu={(e) => e.preventDefault()}
        className="card-img"
      />
    );
  } else if (strng == "application" || strng == "text") {
    let strarray = props.aType.split("/");
    // let strgarray = props.aType.split(".");
    // let docStr = strgarray[strgarray.length - 1];
    let substrng = strarray[1];
    // let url = {resp}
    // "https://docs.google.com/viewer?url=" +
    // ImageData +
    // "&embedded=true";
    if (substrng == "pdf") {
      // let docurl = "https://docs.google.com/gview?url="+resp+"&embedded=true"
      returnValue = isFromAsideCards ? (
        <img
          src={images.pdf_images}
          style={{
            marginTop: "8px",
            border: "1px solid rgb(150,150,150)",
          }}
          onContextMenu={(e) => e.preventDefault()}
          className="card-img"
        />
      ) : (
        <embed
          src={resp}
          style={{
            width: "37vw",
            height: "450px",
          }}
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        ></embed>
      );
    } else if (substrng != "pdf" || strng != "text") {
      // if (docStr == "document" || substrng == "msword") {
      //   returnValue =
      //       <div style={{ position: "relative" }}>
      //         <div
      //           style={{
      //             backgroundColor: "#F5F5F5",
      //             height: "54px",
      //             position: "absolute",
      //             right: " 0px",
      //             top: "0px",
      //             width: "54px",
      //             ZIndex: "2147483647",
      //           }}
      //         ></div>
      //         <embed
      //           src={"https://docs.google.com/gview?url="+resp+"&embedded=true"}
      //           style={{ width: "37vw", height: "var(--sidebar-width)", border: "none" }}
      //         ></embed>

      //       </div>

      // } else {
      let docurl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURI(resp)}`;
      returnValue = isFromAsideCards ? (
        <img
          src={images.doc_image}
          style={{
            marginTop: "8px",
            border: "1px solid rgb(150,150,150)",
          }}
          onContextMenu={(e) => e.preventDefault()}
          className="card-img"
        />
      ) : (
        <embed
          src={docurl}
          style={{
            width: isFromAsideCards ? "5vw" : "37vw",
            height: isFromAsideCards ? "5vw" : "500px",
            border: "none",
          }}
        />
      );
      // }
    }
    // returnValue =
    //   <iframe
    //     src={`${resp}+ "#toolbar=0"`}
    //     style={{ width: "37vw", height: "var(--sidebar-width)" }}
    //     onContextMenu={(e) => {
    //       e.preventDefault();
    //     }}
    //   ></iframe>
  } else if (strng == "audio") {
    if (isFromAsideCards == true) {
      returnValue = (
        <img
          src={images.audio_thumbnail}
          style={{
            marginTop: "8px",
            border: "1px solid rgb(150,150,150)",
          }}
          onContextMenu={(e) => e.preventDefault()}
          className="card-img"
        />
      );
    } else {
      returnValue = (
        <audio
          src={resp}
          style={{ width: "37vw" }}
          controls
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
        ></audio>
      );
    }
  }
  return returnValue;
};

// const getRenderData = (resp, strng, props, isFromAsideCards = false) => {
//   let returnValue = "";
//   if (strng == "image") {
//     returnValue = (
//       <img
//         src={resp}
//         style={{
//           marginTop: "8px",
//           border: "1px solid rgb(150,150,150)",
//         }}
//         onContextMenu={(e) => e.preventDefault()}
//         className="card-img"
//       />
//     );
//   } else if (strng == "application" || strng == "text") {
//     let strarray = props.aType.split("/");
//     // let strgarray = props.aType.split(".");
//     // let docStr = strgarray[strgarray.length - 1];
//     let substrng = strarray[1];
//     // let url = {resp}
//     // "https://docs.google.com/viewer?url=" +
//     // ImageData +
//     // "&embedded=true";
//     if (substrng == "pdf") {
//       // let docurl = "https://docs.google.com/gview?url="+resp+"&embedded=true"
//       returnValue = (
//         <embed
//           src={resp}
//           style={{
//             width: "37vw",
//             height: "450px",
//           }}
//           onContextMenu={(e) => {
//             e.preventDefault();
//           }}
//         ></embed>
//       );
//     } else if (substrng != "pdf" || strng != "text") {
//       // if (docStr == "document" || substrng == "msword") {
//       //   returnValue =
//       //       <div style={{ position: "relative" }}>
//       //         <div
//       //           style={{
//       //             backgroundColor: "#F5F5F5",
//       //             height: "54px",
//       //             position: "absolute",
//       //             right: " 0px",
//       //             top: "0px",
//       //             width: "54px",
//       //             ZIndex: "2147483647",
//       //           }}
//       //         ></div>
//       //         <embed
//       //           src={"https://docs.google.com/gview?url="+resp+"&embedded=true"}
//       //           style={{ width: "37vw", height: "var(--sidebar-width)", border: "none" }}
//       //         ></embed>

//       //       </div>

//       // } else {
//       let docurl = `https://view.officeapps.live.com/op/embed.aspx?src=${resp}`;
//       returnValue = (
//         <embed
//           src={docurl}
//           style={{
//             width: "37vw",
//             height: "500px",
//             border: "none",
//           }}
//         />
//       );
//       // }
//     }
//     // returnValue =
//     //   <iframe
//     //     src={`${resp}+ "#toolbar=0"`}
//     //     style={{ width: "37vw", height: "var(--sidebar-width)" }}
//     //     onContextMenu={(e) => {
//     //       e.preventDefault();
//     //     }}
//     //   ></iframe>
//   } else if (strng == "audio") {
//     returnValue = (
//       <audio
//         src={resp}
//         style={{ width: "37vw" }}
//         controls
//         controlsList="nodownload"
//         onContextMenu={(e) => e.preventDefault()}
//       ></audio>
//     );
//   }
//   return returnValue;
// };

ShowAttachment.propTypes = {
  aType: PropTypes.string,
  attachment: PropTypes.string,
  videoId: PropTypes.string,
  thumbnailId: PropTypes.string,
};

export const setBookmarkImage = (isKnowledge, type, isBookmarkedByMe) => {
  let strarray = type?.split("/");
  let strng = strarray ? strarray[0] : null;
  if (isBookmarkedByMe) {
    if (!isKnowledge) {
      return images.bookmark_question_filled;
    } else {
      if (strng == "video") {
        return images.bookmark_video_filled;
      } else if (strng == "audio") {
        return images.bookmark_audio_filled;
      } else {
        return images.bookmark_doc_filled;
      }
    }
  } else {
    if (!isKnowledge) {
      return images.bookmark_question;
    } else {
      if (strng == "video") {
        return images.bookmark_video;
      } else if (strng == "audio") {
        return images.bookmark_audio;
      } else {
        return images.bookmark_doc;
      }
    }
  }
};

const DataCards2 = (props) => {
  const [like, setLike] = useState(false);
  const [value, setValue] = useState(0);
  const [val, setVal] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [loadmorebtn, setLoadmore] = useState(false);
  const [details, showDetail] = useState(false);
  const [id, setDetail] = useState("");
  const [isKnowledge, setKnowledge] = useState(false);
  const [bookmarked, setBookmark] = useState(false);
  const [systemList, setSystemList] = useState([]);
  const [creatorId, setCreator] = useState();
  const [dataList, setData] = useState([]);
  const [showItemId, setShowItemId] = useState(false);
  // // const [, updateState] = useState();
  // // const forceUpdate = React.useCallback(() => updateState({}), []);

  // const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);

  const forceUpdate = useForceUpdate();

  var { ismore } = props;

  const knowledgeDetailsData = localStorage.getItem("knowledgeDetailsData")
    ? JSON.parse(getFromEncLocalStorage("knowledgeDetailsData"))
    : props.location.pathname;

  useEffect(() => {
    if (showItemId) {
      const showItemIdTimer = setTimeout(() => {
        setShowItemId(false);
      }, 5000);
      return () => clearTimeout(showItemIdTimer);
    }
  }, [showItemId]);

  useEffect(() => {
    getSystem();

    let creator = getFromEncLocalStorage("employeenumber");

    setCreator(creator);
    // setData(props.dataList);
  }, []);

  useEffect(() => {
    setLoading(true);
    let newDataList = [...props.dataList];

    for (let index = 0; index < newDataList?.length; index++) {
      const knowledgeObj = newDataList?.[index];
      createUserNameTaggedLocationString(knowledgeObj);
    }
    debugger;
    setData(newDataList);
    setLoading(false);
  }, [props.dataList]);

  const encryptData = (edata) => {
    let eData = JSON.stringify({ data: edata, encryptionType: true });
    let encryptedData = Encrypt(eData);
    let newData = {
      data: encryptedData,
    };
    return newData;
  };

  const setLoadMore = () => {
    setLoadmore(true);
    storeInEncLocalStorage("position", window.pageYOffset);
    props.rerenderParentCallback(val + 1, props?.dataType);
    setVal(val + 1);
    setLoadmore(false);
  };

  const handleLike = async (isKnowledge, id, creator) => {
    //console.log(`Inside handlelike: isKnowledge=${isKnowledge}, id=${id}, creator=${creator}`)
    setLike(!like);
    let likeKnowledgeData = {
      knowledge_id: id,
      created_by_id: creator,
    };
    //console.log(`Inside handlelike likeKnowledgeData: `, likeKnowledgeData)
    let likeQuestionData = {
      question_id: id,
      created_by_id: creator,
    };
    //console.log(`Inside handlelike likeQuestionData: `, likeQuestionData)
    let likeData = isKnowledge ? likeKnowledgeData : likeQuestionData;

    //console.log(`Inside handlelike likeData: `, likeData)
    let newData = encryptData(likeData);
    //console.log(`Inside handlelike newData: `, newData)
    //console.log(`Inside handlelike window.socketObj: `, window.socketObj)
    // window.socketObj.emit("UpvoteSocket", newData);
    // window.socketObj.on("UpvoteBroadcast", (data) => {
    //   console.log(`Inside handlelike UpvoteBroadcast: `, data )
    //   setUpvotes(data);
    // });

    const employeeNum = getFromEncLocalStorage("employeenumber");
    const firstName = getFromEncLocalStorage("firstname");
    const lastName = getFromEncLocalStorage("lastname");

    const likeDislikeData = {
      knowledge_id: null,
      question_id: null,
      answer_id: null,
      knowledge_base_id: null,
      created_by_id: creator,
      loggedin_userid: employeeNum,
      commenter_name: `${firstName} ${lastName}`,
    };
    // if (props?.knowledgeBaseId) {
    //   likeDislikeData.knowledge_base_id = `${id}`;
    // } else
    if (isKnowledge) {
      likeDislikeData.knowledge_id = `${id}`;
    } else {
      likeDislikeData.question_id = `${id}`;
    }

    const resp = await APICall(likeDislike, likeDislikeData);

    setUpvotes(resp.data);

    //logEvent(analytics(), "like");
  };

  const setUpvotes = (res) => {
    //console.log(`Inside setUpvotes res: `, res)
    let dataObj = res; //Decrypt(res.data);
    //console.log(`Inside setUpvotes dataObj: `, dataObj)
    let respnseObj = dataObj; //JSON.parse(dataObj);
    // //console.log(respnseObj);
    let question_id = respnseObj.id.question_id;
    let knowledge_id = respnseObj.id.knowledge_id;
    let knowledge_base_id = respnseObj.id.knowledge_base_id;
    //console.log(`Inside setUpvotes question_id: `, question_id)
    //console.log(`Inside setUpvotes knowledge_id: `, knowledge_id)
    //console.log(`Inside setUpvotes dataList: `, dataList)
    let data_temp = dataList;
    if (knowledge_id != undefined && knowledge_id != null) {
      data_temp.map((item, i) => {
        if (item.id == knowledge_id && respnseObj.IsSucessful) {
          if (respnseObj.status == "Upvoted") {
            if (respnseObj.id.employeenumber === creatorId) {
              data_temp[i] = {
                ...item,
                likes_histories: [respnseObj.data],
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 1,
              };
            } else {
              data_temp[i] = {
                ...item,
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 1,
              };
            }
          } else {
            if (respnseObj.id.employeenumber === creatorId) {
              data_temp[i] = {
                ...item,
                likes_histories: [],
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 0,
              };
            } else {
              data_temp[i] = {
                ...item,
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 0,
              };
            }
          }
        }
      });
      //console.log(`Inside setUpvotes data_temp: `, data_temp)
      setData(data_temp);
      //dataList = data_temp;
      setValue(value + 1);
    } else if (question_id != undefined && question_id != null) {
      data_temp.map((item, i) => {
        if (item.id == question_id && respnseObj.IsSucessful) {
          if (respnseObj.status == "Upvoted") {
            if (respnseObj.id.employeenumber === creatorId) {
              data_temp[i] = {
                ...item,
                likes_histories: [respnseObj.data],
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 1,
              };
            } else {
              data_temp[i] = {
                ...item,
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 1,
              };
            }
          } else {
            if (respnseObj.id.employeenumber === creatorId) {
              data_temp[i] = {
                ...item,
                likes_histories: [],
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 0,
              };
            } else {
              data_temp[i] = {
                ...item,
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 0,
              };
            }
          }
        }
      });
      //console.log(`Inside setUpvotes question_id data_temp: `, data_temp)
      setData(data_temp);
      //dataList = data_temp;
      setValue(value + 1);
    } else if (knowledge_base_id != undefined && knowledge_base_id != null) {
      data_temp.map((item, i) => {
        if (item.id == knowledge_base_id && respnseObj.IsSucessful) {
          if (respnseObj.status == "Upvoted") {
            if (respnseObj.id.employeenumber === creatorId) {
              data_temp[i] = {
                ...item,
                likes_histories: [respnseObj.data],
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 1,
              };
            } else {
              data_temp[i] = {
                ...item,
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 1,
              };
            }
          } else {
            if (respnseObj.id.employeenumber === creatorId) {
              data_temp[i] = {
                ...item,
                likes_histories: [],
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 0,
              };
            } else {
              data_temp[i] = {
                ...item,
                upvotes: respnseObj.upVote.upvotes,
                isLikedByMe: 0,
              };
            }
          }
        }
      });
      //console.log(`Inside setUpvotes data_temp: `, data_temp)
      setData(data_temp);
      //dataList = data_temp;
      setValue(value + 1);
    }
  };

  const updateBookmark = async (id, isKnowledge, idIndex) => {
    setBookmark(!bookmarked);
    let bookmarkKnowledgeData = {
      knowledge_id: id,
    };
    let bookmarkQuestionData = {
      question_id: id,
    };

    let bookmarkData = isKnowledge
      ? bookmarkKnowledgeData
      : bookmarkQuestionData;
    if (props?.knowledgeBaseId) {
      bookmarkData.KnowledgebaseId = props?.knowledgeBaseId;
    }
    setLoading(true);
    const res = await BookmarksService.updateBookmarks(bookmarkData);
    if (res) {
      let data_temp = dataList;
      if (props.isBookmarks) {
        data_temp.map((item, index) => {
          if (item.id == id) {
            data_temp.splice(index, 1);
          }
        });
        setData(data_temp);
        //dataList = data_temp;
      } else {
        data_temp.map((item, index) => {
          if (index == idIndex) {
            if (res != 1) {
              if (
                !item?.bookmarked_histories ||
                item?.bookmarked_histories?.length == 0
              ) {
                item.bookmarked_histories = Array(1);
              }
              item.bookmarked_histories[0] = res;
            } else {
              item.bookmarked_histories = [];
            }
          }
        });

        setData(data_temp);
        //dataList = data_temp;
      }
      store.dispatch(updateBookmarkAction());
    }
    //logEvent(analytics(), "bookmark");
    setLoading(false);

    if (props?.setBookmarkClickedCallback)
      props?.setBookmarkClickedCallback(true);
    // setValue(value + 1);
  };

  const getSystem = async () => {
    setLoading(true);
    const res = await CommonService.getSystemList("");
    if (res) {
      setSystemList(res);
    }
    setLoading(false);
  };

  const setComments = (respnseObj) => {
    // let respnseObj = JSON.parse(Decrypt(res.data));
    let knowledge_id = respnseObj.data.knowledge_id;
    if (respnseObj.IsSucessful == 1) {
      let data_temp = dataList;
      data_temp.map(function (item, i) {
        if (
          item.id == knowledge_id &&
          item.isKnowledge == 1 &&
          item.commentCount === respnseObj.count - 1
        ) {
          data_temp[i] = {
            ...item,
            commentCount: item.commentCount + 1,
            comment_data: [respnseObj.data],
          };
        }
      });
      //dataList = data_temp;
      setData(data_temp);
      setValue(value + 1);
    }
  };

  const setAnswers = (respnseObj) => {
    // let respnseObj = JSON.parse(Decrypt(res.data));
    let question_id = respnseObj.data.question_id;
    if (respnseObj.IsSucessful == 1) {
      let data_temp = dataList;
      data_temp.map(function (item, i) {
        if (
          item.id == question_id &&
          item.isKnowledge == 0 &&
          item.answerCount === respnseObj.count - 1
        ) {
          data_temp[i] = {
            ...item,
            answerCount: item.answerCount + 1,
            answer_data: [respnseObj.data],
          };
        }
      });
      //dataList = data_temp;
      setData(data_temp);
      setValue(value + 1);
    }
  };

  const setDetails = (id, isKnowledge) => {
    storeInEncLocalStorage("position", window.pageYOffset);
    setDetail(id);
    showDetail(true);
    setKnowledge(isKnowledge);
  };

  if (details) {
    let path = props.location.pathname;

    if (
      path == "/details" &&
      knowledgeDetailsData &&
      knowledgeDetailsData.from
    ) {
      path = knowledgeDetailsData.from;
    }

    const detailsData = {
      id: id,
      isKnowledge: isKnowledge,
      from: path,
      redirected: true,
    };

    storeInEncLocalStorage("knowledgeDetailsData", JSON.stringify(detailsData));

    return (
      <Redirect
        to={{
          pathname: "/details",
          state: detailsData,
        }}
      />
    );
  }

  return (
    <div>
      <Loadspinner
        filename="DataCards2.js"
        isLoading={isLoading && dataList.length <= 10}
        isMiddle="true"
      />
      {dataList.length == 0 ? (
        isLoading ? (
          <div className="card text-center" style={{ width: "40vw" }}>
            <div className="card-body">
              <p>Loading...</p>
            </div>
          </div>
        ) : (
          <div className="card text-center" style={{ width: "40vw" }}>
            <div className="card-body">
              <p>No Data available</p>
            </div>
          </div>
        )
      ) : (
        dataList.map((item, index) => (
          <div className="card home-card" key={index}>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-xs-6 d-flex">
                  {item.creator_profile_pic ? (
                    <img
                      src={item.creator_profile_pic}
                      alt="Profile pic"
                      className="dp-img"
                    />
                  ) : (
                    <Avatar name={item.creator} size="50px" round={true} />
                  )}

                  <div
                    style={{ margin: "5px 0 0 10px" }}
                    className="display-column"
                    onDoubleClick={() => setShowItemId(true)}
                  >
                    <h6>
                      <b>{item?.creatorNameField?.[0]}</b>
                      <span className="small-text">
                        {item?.creatorNameField?.[1]}
                      </span>
                      <b>
                        {" "}
                        {item?.creatorNameField?.[2]}
                        {item?.creatorNameField?.[3]}
                      </b>
                      <span className="small-text">
                        {item?.creatorNameField?.[4]}
                      </span>
                    </h6>
                    <p className="small-text text-danger font-weight-bold">
                      {item?.creatorNameField?.[5]}
                    </p>
                    <p className={`small-text ${showItemId ? "" : "d-none"}`}>
                      {item.id}
                    </p>
                    <p className={`small-text ${showItemId ? "" : "d-none"}`}>
                      {item?.KnowledgeStatusText}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-6 d-flex flex-column flex-wrap align-content-end">
                  {/* <img src={images.dots} className="card-dots" /> */}
                  <div className="row justify-content-end">
                    <div className="col-1 d-flex justify-content-end mx-2">
                      {[8].includes(item?.VerificationStatus) && (
                        <CheckCircleIcon
                          width={10}
                          height={10}
                          sx={{ color: green[500] }}
                        />
                      )}
                    </div>
                    <div className="col-2 d-flex justify-content-end mx-2">
                      <img
                        src={setBookmarkImage(
                          item.isKnowledge,
                          item.attachment_file_type,
                          item?.isBookmarkedByMe ||
                          item?.bookmarked_histories?.length > 0
                        )}
                        style={{
                          cursor: "pointer",
                          width: "2rem",
                          marginTop: "-1rem",
                        }}
                        onClick={() => {
                          updateBookmark(item.id, item.isKnowledge, index);
                          forceUpdate();
                        }}
                        // className="card-banner"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Bookmark"
                      />
                    </div>
                    <div className="col-3 d-flex justify-content-end ml-2">
                      {item.status == 1 ? (
                        <>
                          <img
                            src={images.bookmark_filled}
                            className="bookmark-filled"
                          />
                          <div
                            style={{
                              display: "flex",
                              right: "0.35rem",
                              position: "absolute",
                              top: "0.75rem",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                color: "white",
                                position: "relative",
                              }}
                            >
                              Proven
                            </span>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <div className="card-profile-right-time small-text d-flex justify-content-end">
                      {/* {systemList.length == 0
                        ? null
                        : systemList.map((system) =>
                            system.id == item.system_id ? (
                              <span key={system.id}>{system.system_desc}</span>
                            ) : null
                          )} */}

                      <span>{item.system_desc || ""}</span>
                      <span> | </span>
                      <span>
                        {item?.created_date &&
                          format(
                            new Date(item?.created_date),
                            "MMMM dd, yyyy HH:mm"
                          )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <h6
                style={{ cursor: "pointer", margin: "15px 0 5px 0" }}
                onClick={() => {
                  setDetails(item.id, item.isKnowledge);
                }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="View details"
              >
                <b>
                  {/* {item.title.length > 60
                    ? item.title.substring(0, 60) + "..."
                    : item.title} */}
                  {item.title}
                </b>
              </h6>
              <small
                className="card-text"
                onClick={() => {
                  setDetails(item.id, item.isKnowledge);
                }}
                style={{ cursor: "pointer", marginBottom: "5px" }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="View details"
              >
                {/* {item.description.length > 160
                  ? item.description.substring(0, 160) + "..."
                  : item.description} */}
                {item.description}
              </small>
              {(item.attachment_file_type !== null &&
                item.attachment !== null) ||
                (item.video_id != null && item.video_id != "") ? (
                <ShowAttachment
                  ThumbnailGcp={item.thumbnail}
                  GcpVideoUrl={item.VideoUrl}
                  aType={item.attachment_file_type}
                  attachment={item.attachment}
                  videoId={item.video_id}
                  thumbnailId={item.thumbnailId}
                  thumbnail={item.thumbnail}
                  videoMetadata={item.VideoMetadata}
                />
              ) : null}
              {/* {item.transcription_data != null &&
              item.transcription_data != "{}" &&
              item.transcription_data != "" ? (
                <div className="row">
                  <div className="col-8"></div>
                  <div className="col-4">
                    <a
                      className="transcript-link"
                      style={{ cursor: "pointer", float: "right" }}
                      onClick={() => {
                        setDetails(item.id, item.isKnowledge);
                      }}
                    >
                      View Transcript
                    </a>
                  </div>
                </div>
              ) : null} */}
              <div className="d-flex flex-wrap">
                {item?.hashtags &&
                  item?.hashtags?.split(",")?.map((ht, htIdx) => {
                    return (
                      <div key={`key_${htIdx}`} className="px-2 py-1">
                        <Chip label={`#${ht}`} className="hashtag-chip" />
                      </div>
                    );
                  })}
              </div>
              <div
                className="justify-space-between"
                style={{ marginTop: "10px" }}
              >
                <div
                  className="card-like"
                  onClick={() =>
                    handleLike(item.isKnowledge, item.id, item.created_by_id)
                  }
                  style={{ cursor: "pointer" }}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title={item.isKnowledge ? "Like" : "Upvotes"}
                >
                  <img
                    src={
                      item?.isLikedByMe || item?.likes_histories?.length > 0
                        ? images.like_filled
                        : images.like
                    }
                    alt="like"
                    className="like-img"
                  />
                  <small style={{ padding: "5px" }}>
                    {item.upvotes == null ? 0 : item.upvotes}
                  </small>
                  <h6 style={{ margin: "0 5px" }}>
                    {item.isKnowledge ? "Likes" : "Upvotes"}
                  </h6>
                </div>
                <div
                  className="card-like"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="View details"
                  style={{ cursor: "pointer" }}
                >
                  <img src={images.comment} alt="comment" />
                  <div
                    onClick={() => {
                      setDetails(item.id, item?.isKnowledge);
                    }}
                  >
                    <h6 style={{ margin: "0 5px" }}>
                      {item?.isKnowledge ? "Comments" : "Answers"}
                    </h6>
                  </div>
                  <small>
                    (
                    {item?.isKnowledge
                      ? item?.commentCount || item?.comment_data?.length || 0
                      : item?.answerCount || item?.answer_data?.length || 0}
                    )
                  </small>
                </div>
              </div>
              <hr />
              {item?.isKnowledge ? (
                <AddComment
                  id={item.id}
                  sendComment={setComments}
                  creator={item.created_by_id}
                />
              ) : (
                <AddAnswer
                  id={item.id}
                  sendAns={setAnswers}
                  creator={item.created_by_id}
                />
              )}
            </div>
          </div>
        ))
      )}

      {!isLoading && ismore && (
        <div>
          <button onClick={setLoadMore} className="btn loadmore-btn">
            <span>Load more</span>
          </button>
        </div>
      )}
      {loadmorebtn && (
        <div
          style={{
            position: "fixed",
            top: "80%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            zIndex: 9999,
          }}
        >
          <Loader type="ThreeDots" color="#00BFFF" height={20} width={40} />
        </div>
      )}
    </div>
  );
};

export default withRouter(DataCards2);

DataCards2.propTypes = {
  dataList: PropTypes.array,
  rerenderParentCallback: PropTypes.func,
  setBookmarkClickedCallback: PropTypes.func,
  setPosition: PropTypes.func,
  location: PropTypes.object,
  ismore: PropTypes.bool,
  isBookmarks: PropTypes.bool,
  knowledgeBaseId: PropTypes.string,
  dataType: PropTypes.number,
};
export const createUserNameTaggedLocationString = (knowledgeObj) => {
  let creatorNameField = Array(6);
  creatorNameField[0] = `${knowledgeObj.creator}`;
  if (knowledgeObj?.TaggedUserNames) {
    const TaggedUserNamesArr = knowledgeObj?.TaggedUserNames?.split(",");
    if (TaggedUserNamesArr.length > 0) {
      creatorNameField[1] = ` is with`;
      creatorNameField[2] = ` ${TaggedUserNamesArr[0]}`;
      if (TaggedUserNamesArr.length > 1) {
        let TaggedUserNamesLength = TaggedUserNamesArr.length - 1;
        //if (showFullName) {
        creatorNameField[3] = (
          <Tooltip
            title={
              <span style={{ whiteSpace: "pre-line" }}>
                {TaggedUserNamesArr?.filter((f, idx) => idx > 0)?.join(",\n")}
              </span>
            }
          >
            <Typography variant="body1" component="span">
              <b>{`, ${` & ${TaggedUserNamesLength} other${TaggedUserNamesLength > 1 ? "s" : ""
                }`}`}</b>
            </Typography>
          </Tooltip>
        );
        // } else {
        //   creatorNameField[3] = ` & ${TaggedUserNamesLength} other${TaggedUserNamesLength > 1 ? 's' : ''}`;
        // }
      }
    }
  }
  if (knowledgeObj?.Location) {
    creatorNameField[4] = ` at`;
    creatorNameField[5] = ` ${knowledgeObj?.Location}`;
  }
  knowledgeObj.creatorNameField = creatorNameField;
};
